import PropTypes from 'prop-types';
import React from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import FormControlLabel from '../FormControlLabel';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
import FormContext from '../tools/FormContext';
import { canTouch } from '../tools/touch';
export default function FormControl(_ref) {
  var id = _ref.id,
      className = _ref.className,
      control = _ref.control,
      children = _ref.children,
      size = _ref.size,
      disabled = _ref.disabled,
      checked = _ref.checked,
      uncheckable = _ref.uncheckable;
  var WrapperTag = canTouch ? 'span' : 'label';
  var ControlTag = canTouch ? 'label' : React.Fragment;
  var controlProps = canTouch ? {
    className: 'jmtd-form-control-control-label'
  } : null;
  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    context: FormContext,
    disabled: disabled,
    checked: checked
  }, function (_ref2) {
    var configDisabled = _ref2.disabled,
        configChecked = _ref2.checked;
    return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
      size: size
    }, function (_ref3) {
      var configSize = _ref3.size;
      return /*#__PURE__*/React.createElement(WrapperTag, {
        id: id,
        className: classNames('jmtd-form-control', className, {
          'jmtd-form-control-large': configSize === 'large',
          'jmtd-form-control-small': configSize === 'small',
          'jmtd-form-control-mini': configSize === 'mini',
          'jmtd-form-control-checked': configChecked,
          'jmtd-form-control-disabled': configDisabled,
          'jmtd-form-control-uncheckable': uncheckable,
          'jmtd-form-control-touch': canTouch
        }),
        "data-event-content": true,
        "data-event-name": checked ? 'uncheck' : 'check'
      }, /*#__PURE__*/React.createElement(ControlTag, controlProps, control && /*#__PURE__*/React.cloneElement(control, {
        className: classNames('jmtd-form-control-control', control.props.className)
      })), /*#__PURE__*/React.createElement(FormControlLabel, null, children));
    });
  });
}
FormControl.propTypes = {
  control: PropTypes.node,
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  uncheckable: PropTypes.bool
};
FormControl.defaultProps = {
  control: null,
  id: null,
  children: null,
  className: '',
  disabled: null,
  size: null,
  checked: null,
  uncheckable: null
};